import { AxiosInstance } from 'axios';
import { QueryStringBuilder } from '../helpers/query-string-builder';
import { IUserTask } from '../models/user-task/user-task';
import { IUserTaskListRequest } from '../models/user-task/user-task-list-request';

export class UserTaskClient {

    constructor(private axiosClient: AxiosInstance) {

    }

    public get apiUrl() {
        return `/userTask`;
    }

    public async list(request?: IUserTaskListRequest): Promise<IUserTask[]> {

        try {

            const url = new QueryStringBuilder()
                .withQueryIfNotEmpty('cultureAlias', request?.cultureAlias)
                .withQueryIfNotEmpty('staleEntityType', request?.staleEntityType)
                .withQueryIfNotEmpty('staleEntityId', request?.staleEntityId)
                .build(`${this.apiUrl}`);

            const response = await this.axiosClient.get(url);

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }
}
